<!-- This component is responsible on generating the layout per each Pass step.
IMPORTANT: Set the right 'steps' property values.
Each step creates its own content components -->
<template>
  <div>
    <div v-for="(data, index) in steps" :key="index" class="pass-step">
      <div class="d-flex flex-row">
        <div class="pass-step-number">
          <!-- convert index to nonzero value to display as step number -->
          <p>{{ nonZero(index) }}</p>
        </div>

        <div>
          <p class="pass-step-title">
            {{ stepWithID(data).title }}
            <i class="fa fa-check" v-if="isCompleted(data)"></i>
          </p>

          <!-- START HERE
          Add template or component content of the step-->
          <!--VERIFY IDENTITY-->
          <!--set necessary props only-->
          <step-verify
            v-if="isVerifyIdentity(data)"
            :isUserVerified="isUserVerified"
            :stepInquiryQuestion="reviewInquiryQuestion"
            :userProfile="userProfile"
            :goToUrl="goToUrl"
          />

          <!--REVIEW AGREEMENTS-->
          <step-review-agreements
            v-if="isReviewAgreements(data)"
            :passDetail="passDetail"
            :isPreview="isReviewPreviewOnly"
            :isToVerifyIdentity="isToVerifyIdentity"
            :stepInquiryQuestion="reviewInquiryQuestion"
            :updateFunc="updateReviewFunc"
            :didAgree="isReviewCompleted"
            :goToUrl="goToUrl"
          />

          <!--SHARE DETAILS-->
          <step-share-details
            v-if="isShareDetails(data)"
            :passDetail="passDetail"
            :isPreview="isDetailsPreviewOnly"
            :isToVerifyIdentity="isToVerifyIdentity"
            :isUserInvited="isUserInvited"
            :isRequestNeedsApproval="isRequestNeedsApproval"
            :userProfile="userProfile"
            :updateFunc="updateShareDetailsFunc"
            :stepInquiryQuestion="shareDetailsInquiryQuestion"
            :goToUrl="goToUrl"
            :individualPass="individualPass"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/styles/pass-share-steps.css'
import PassShareStepVerify from './PassShareStepVerify'
import PassShareStepReview from './PassShareStepReview'
import PassShareStepUserDetails from './PassShareStepUserDetails'

export default {
  name: 'pass-share-step',
  components: {
    // Need to add name for recursive components to work.
    'step-verify': PassShareStepVerify,
    'step-review-agreements': PassShareStepReview,
    'step-share-details': PassShareStepUserDetails
  },
  data() {
    return {
      source: [
        { id: 'verify', title: 'Verify identity' },
        { id: 'review', title: 'Review agreements' },
        { id: 'share', title: 'Share details' }
      ]
    }
  },
  props: {
    goToUrl: String,
    steps: {
      type: Array,
      required: true
    },
    isToVerifyIdentity: {
      type: Boolean,
      required: true,
      default: true
    },
    passDetail: {
      type: Object,
      required: true
    },
    // Agreements
    isReviewCompleted: Boolean,
    reviewInquiryQuestion: String,
    updateReviewFunc: Function,

    //  Verification
    isUserVerified: Boolean,
    userProfile: Object,

    // Invite
    isUserInvited: Boolean,
    isRequestNeedsApproval: Boolean,

    // Share Details
    updateShareDetailsFunc: Function,
    shareDetailsInquiryQuestion: String,
    // previews
    // if true, the content of each step is not displayed.
    activeStep: {
      type: String,
      required: true
    },
    individualPass: Object
  },
  computed: {
    isReviewPreviewOnly: function() {
      var isPreview = true
      if (this.activeStep === 'review' || this.activeStep === 'share') {
        isPreview = false
      }
      return isPreview
    },
    isDetailsPreviewOnly: function() {
      var isPreview = true
      if (this.activeStep === 'share') {
        isPreview = false
      }
      return isPreview
    }
  },
  methods: {
    stepWithID: function(id) {
      return this.searchStep(id)[0]
    },
    searchStep: function(id) {
      return this.source.filter(function(step) {
        return step.id === id
      })
    },
    nonZero: function(index) {
      return index + 1
    },
    isReviewAgreements: function(id) {
      return id === 'review'
    },
    isVerifyIdentity: function(id) {
      return id === 'verify'
    },
    isShareDetails: function(id) {
      return id === 'share'
    },
    isCompleted: function(id) {
      if (id === 'verify') {
        return this.isUserVerified
      }

      if (id === 'review') {
        return this.isReviewCompleted
      }

      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/share/passes/PassShareSteps.vue